export default {
  props: {
    isHorizontal: Boolean,
    isVertical: Boolean,
    lists: Array,
    listsClass: String,
    title: String,
    linkClass: String,
  },
}
